import { MenuItem, TextFieldProps } from "@mui/material";
import { RHFSelect } from "./RHFSelect";

type RHFSelectProps = TextFieldProps & {
  name: string;
  native?: boolean;
  maxHeight?: boolean | number;
  options: {label: string, value: string | number}[]
  fullWidth?: boolean
};

// eslint-disable-next-line arrow-body-style
export const RHFSelectMenu = ({ name, label, options, fullWidth=true, ...other }: RHFSelectProps) => {
  return (
    <RHFSelect
      fullWidth={fullWidth}
      name={name}
      label={label}
      InputLabelProps={{ shrink: true }}
      SelectProps={{
        native: false,
        sx: {
          textTransform: 'capitalize',
          '& .MuiInputBase-input': {
            font: 'menu',
          },
        },
      }}
      size="small"
      {...other}
    >
      {options.map((option) => (
        <MenuItem
          key={option.value}
          value={option.value}
          sx={{
            mx: 1,
            my: 0.5,
            borderRadius: 0.75,
            typography: 'body2',
            textTransform: 'capitalize',
            font: 'menu',
          }}
        >
          {option.label}
        </MenuItem>
      ))}
    </RHFSelect>
  );
};
